module.exports = __webpack_public_path__ + "static/0075-8eaa8e943fdd209211f06cc50c2fea7a.png";